import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { Invoice, InvoiceProps } from './invoice/invoice';

export interface InvoiceHistoryProps {
  data: InvoiceProps[];
  status: LoadingState;
}

export const InvoiceHistory = types
  .model({
    data: types.optional(types.array(Invoice), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: InvoiceHistoryProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.billings.invoiceHistory,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setStore();
    },
    async update(): Promise<void> {
      await self.setStore();
    },
  }))
  .views((self) => ({
    getInvoiceHistoryList(): InvoiceProps[] {
      const { data } = self;
      return [...getSnapshot(data)];
    },
  }));

export const invoiceHistory = InvoiceHistory.create();
export type InvoiceHistorySnapshot = SnapshotIn<typeof InvoiceHistory>;
export type InvoiceHistoryInstance = Instance<typeof InvoiceHistory>;
export default invoiceHistory;
